// @ts-nocheck

import PropTypes from 'prop-types'
import React from 'react'

import ResidentPictureName from '../../ResidentPictureName/ResidentPictureName'

export default function ResidentCell(props) {
  const { onSelect, resident } = props

  return <ResidentPictureName data={resident} onSelect={onSelect} />
}

ResidentCell.propTypes = {
  onSelect: PropTypes.func,
  resident: PropTypes.object.isRequired
}
